export default {
  notFoundCargoType:
    "Maaf, jadwal kargo yang Anda pilih sudah penuh atau tidak tersedia",
  successCreateMessage:
    "Pengiriman kargo dengan nomor<br /><b>“{cargoNo}”</b> berhasil dibuat.",
  successCreateMessageV2:
    "Pengiriman kargo dengan nomor<b> “{cargoNo}”</b><br />berhasil dibuat.",
  partialCreateMessage:
    "Beberapa No. STT berhasil dibuat jadwal pengiriman kargo<br />dengan nomor <b>“{cargoNo}”</b>. Namun terdapat kegagalan<br />pada beberapa STT. Silahkan hapus STT bermasalah untuk<br />melanjutkan pengiriman kargo.",
  confirmCreateCargoTitle: "Konfirmasi Pembuatan?",
  placeholderAdd: "Contoh: no. STT/bagging: 99LP1234567890123/88-22-12345678",
  secondPlaceholderAdd: "Masukan No. STT/Shipment/Bag ",
  confirmSubtitleEditCargo:
    "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.",
  titlePopupEditCargo: "Perubahan Berhasil !",
  subtitlePopupEditCargo:
    "Detail pengiriman kargo dengan nomor<br/><b>“{cargoNo}”</b> berhasil diubah.",
  subtitlePartialEditCargo:
    "Beberapa No. STT dengan nomor kargo <b>“{cargoNo}”</b><br />berhasil diubah jadwal pengiriman kargo. Namun terdapat<br />kegagalan pada beberapa STT. Silahkan download untuk<br/>mengatahui kesalahan.",
  editDimensionInfo: "Edit jika dimensi berubah",
  volumeWeightBag: "Berat volume bag",
  errorBagExceed: "Berat bag melebihi berat STT.",
  kotaAsal: "Kota Asal konsol",
  kotaTujuanBag: "Kota Tujuan Bag",
  createdBy: "Dibuat oleh",
  createdDate: "Tanggal dibuat",
  updatedBy: "Diubah oleh",
  updatedDate: "Tanggal diubah",
  bagGrossWeight: "Berat kotor bag",
  bagVolumeWeight: "Berat volume bag",
  createSuccessTitle: "Pembuatan Bagging Berhasil !",
  createSuccessMessage: "Bagging berhasil dibuat.",
  createRtcSuccessTitle: "Pembuatan Bagging Siap di Kargo Berhasil",
  createRtcSuccessMessage:
    "Bagging berhasil dibuat dan akan terupdate di Siap di Kargo",
  createPartialMessage:
    "Beberapa No. STT berhasil dibuat menjadi Bagging, namun terdapat kegagalan pada beberapa STT.<br />Silahkan download untuk mengetahui kesalahan.",
  createFailedTitle: "Pembuatan Bagging Gagal !",
  createFailedMessage: "Bagging gagal dibuat.",
  scanSttFailedTitle: "Scan No. STT Gagal",
  addSttFailedTitle: "Tambah No. STT Gagal",
  updateSuccessTitle: "Perubahan Berhasil Disimpan !",
  updatePartialTitle: "Perubahan Status Berhasil !",
  updatePartialMessage:
    "Beberapa status STT berhasil diupdate menjadi Bagging, namun terdapat kegagalan pada beberapa STT. Silahkan download untuk mengetahui kesalahan.",
  updateFailedTitle: "Perubahan Status Gagal !",
  updateFailedMessage: "Perubahan status Bagging gagal dibuat.",
  successAddSttNumber: "Berhasil menambahkan No. STT!",
  yes: "YA",
  no: "Tidak",
  scanFailedListTitle: "Daftar STT/Bag gagal scan",
  excel: {
    title: "STT gagal scan",
    noStt: "Nomor STT/Bag",
    status: "Status Terakhir STT/Bag",
    reason: "Alasan Gagal"
  },
  tabs: {
    bookingSuccess: "Berhasil Booking",
    bookingInProgressWithCount: "Dalam Proses Booking({count})",
    bookingCanceled: "Dibatalkan/Gagal Booking",
    readyToCargoInProgress: "Dalam Proses Siap Dikargo",
    readyToCargoList: "Daftar Siap Dikargo"
  },
  actions: {
    bookingCargo: "Booking Kargo",
    bookingNow: "Booking sekarang",
    createNewBooking: "Booking Baru",
    chooseSchedule: "Pilih jadwal",
    continue: "Lanjutkan",
    chooseCargo: "Pilih kargo",
    add: "Tambah",
    edit: "Ubah",
    save: "Simpan",
    back: "Kembali",
    cancel: "Batal",
    cancelBooking: "Batalkan",
    delete: "Hapus",
    rebook: "Booking Ulang",
    process: "Proses",
    processCargo: "Proses Kargo",
    bookAndPrintPdf: "Booking & Print PDF",
    bookAndPrintLabel: "Booking & Print Label",
    editCargo: "Ubah Kargo",
    editAndPrintPdf: "Ubah & Print PDF",
    editAndPrintLabel: "Ubah & Print Label",
    printLabel: "Cetak label",
    printManifestCargo: "Cetak manifest kargo",
    printPti: "Cetak PTI",
    printSptj: "Cetak SPTJ",
    printCargoReceipt: "Print resi kargo",
    printAwbLionCargo: "AWB Lion Cargo",
    downloadEpl: "Download EPL",
    download: "Download",
    downloadExcel: "Unduh excel",
    yesDelete: "Ya, Hapus",
    yesRebook: "Ya, Booking ulang",
    changeTransport: "Ubah Transportasi",
    saveTransport: "Simpan transportasi",
    otherTransport: "Transportasi Lain",
    editPieces: "Ubah Koli",
    inspect: "Periksa",
    viewDetail: "Lihat Detail",
    manualInput: "Isi Manual",
    checkAgain: "Cek Kembali",
    reset: "Reset",
    apply: "Terapkan",
    changeSearch: "Ubah Pencarian",
    reload: "Muat ulang",
    leave: "Keluar",
    stayHere: "Tetap di sini",
    ok: "OK",
    yes: "Ya",
    no: "Tidak"
  },
  labels: {
    cargo: "Kargo",
    cargoLowercase: "kargo",
    bookingNumber: "No. Booking",
    cargoNumber: "No. Kargo",
    cargoNumberSmu: "No. Kargo/SMU",
    cargoNumberLowercase: "No. kargo",
    flightNumber: "No. Penerbangan",
    flightNumberLong: "Nomor penerbangan",
    vehicleSerialNumber: "No. Seri Kendaraan",
    vehicleSerialOrFlightNumber: "No. seri kendaraan/</br>penerbangan",
    cargoType: "Tipe Kargo",
    cargoTypeLowercase: "Tipe kargo",
    userType: "Tipe User",
    partnerName: "Nama Partner",
    date: "Tanggal",
    day: "hari",
    noReference: "No. Referensi",
    noReferenceLowercase: "No. referensi",
    noBag: "No. Bag",
    createdBy: "Dibuat oleh",
    updatedBy: "Diubah oleh",
    lastUpdated: "Terakhir diperbarui",
    consoleOriginCity: "Kota asal konsol",
    bagDestinationCity: "Kota tujuan bag",
    courier: "Kurir",
    noStt: "No. STT",
    failedSttCount: "No. STT Gagal",
    successSttCount: "No. STT Sukses",
    noSttBagging: "No. STT/bagging",
    noSttOrBagging: "No. STT/bagging",
    commodity: "Komoditas",
    cargoCommodity: "Komoditas Kargo",
    cargoCommodityLowercase: "Komoditas kargo",
    cargoCommodityGroup: "Komoditas group (kargo)",
    cargoProduct: "Produk Kargo",
    cargoProductLowercase: "Produk kargo",
    cargoProductType: "Tipe produk kargo",
    shipmentType: "Jenis pengiriman",
    product: "Produk",
    natureOfGoodsNog: "Nature of Goods (NOG)",
    shipmentDetail: "Detail Pengiriman",
    shipmentDetailLowercase: "Detail pengiriman",
    cargoDetail: "Detail kargo",
    pieceDetail: "Detail koli",
    route: "Rute",
    nog: "NOG",
    shc: "SHC",
    etdEta: "ETD/ETA",
    atdAta: "ATD/ATA",
    chargeableGrossVolumeKg: "Chargeable/Gross/Volume (kg)",
    cargoChargeableWeightShort: "Chargeable Bag",
    chargeableWeightCargo: "Chargeable weight kargo",
    chargeableWeightStt: "Chargeable weight (STT)",
    chargeableWeightReweigh: "Chargeable weight (Timbang ulang)",
    grossWeight: "Berat kotor",
    grossWeightStt: "Berat kotor (STT)",
    grossWeightSttShort: "Berat kotor STT",
    grossWeightReweigh: "Berat kotor (Timbang ulang)",
    grossWeightCargo: "Berat kotor kargo",
    totalGrossWeight: "Total Berat Kotor",
    totalDimensionWeight: "Total Berat Dimensi",
    totalCargoGrossWeightTitle: "Total Berat Kotor Kargo",
    totalCargoGrossWeight: "Total berat kotor kargo",
    totalActualCargoGrossWeight: "Total berat kotor kargo aktual",
    totalActualCargoGrossWeightTitle: "Total Berat Kotor Kargo Aktual",
    totalActualGrossWeight: "Total berat kotor aktual",
    totalActualCargoGrossWeightManifest: "Total Aktual Kargo Berat Kotor",
    actualTotalCargoGrossWeightLabel: "Aktual Total Berat Kotor Kargo",
    volumeWeight: "Berat volume",
    volumeWeightStt: "Berat volume (STT)",
    volumeWeightSttShort: "Berat volume STT",
    volumeWeightReweigh: "Berat volume (Timbang ulang)",
    volumeWeightCargo: "Berat volume kargo",
    totalVolumeWeight: "Total Berat Volume Kargo",
    totalCargoVolumeWeight: "Total berat volume kargo",
    totalActualCargoVolumeWeight: "Total berat volume kargo aktual",
    totalActualCargoVolumeWeightTitle: "Total Berat Volume Kargo Aktual",
    totalActualVolumeWeight: "Total berat volume aktual",
    totalActualCargoVolumeWeightManifest: "Total Aktual Kargo Berat Dimensi",
    actualTotalCargoVolumeWeightLabel: "Aktual Total Berat Dimensi Kargo",
    totalEstimatedCargoGrossWeight: "Total Est. Kargo Berat Kotor",
    totalEstimatedCargoVolumeWeight: "Total Est. Kargo Berat Dimensi",
    totalActualWeight: "Total berat aktual",
    totalCargoWeight: "Total berat kargo",
    totalStt: "Total STT",
    totalSttPieces: "Total STT/koli",
    pieces: "Koli",
    totalPieces: "Total Koli",
    totalPiecesLowercase: "Total koli",
    totalActualPieces: "Total koli aktual",
    cargoPieces: "Koli kargo",
    pieceNumber: "Koli Ke",
    dimension: "Dimensi",
    weightDimension: "Dimensi & berat",
    cargoDimension: "Dimensi kargo",
    packageDimension: "Dimensi/paket (P x L x T)",
    estimatedDepartureArrival: "Estimasi keberangkatan/kedatangan",
    pieceValue: "Nilai Koli",
    createdAt: "Tanggal dibuat",
    updatedAt: "Tanggal diubah",
    departureDate: "Tanggal keberangkatan",
    arrivalDate: "Tanggal kedatangan",
    departureDateTitle: "Tanggal Keberangkatan",
    arrivalDateTitle: "Tanggal Kedatangan",
    departureTime: "Waktu Berangkat",
    arrivalTime: "Waktu Tiba",
    originCity: "Kota asal",
    destinationCity: "Kota tujuan",
    originAirport: "Bandara asal",
    destinationAirport: "Bandara tujuan",
    destinationAirportCode: "Kode bandara tujuan",
    originDestinationCities: "Kota asal - tujuan",
    cargoStatus: "Status kargo",
    failedReason: "Alasan gagal",
    manage: "Atur",
    grossVolumeWeightKg: "Berat kotor/volume (kg)",
    weightDifference: "Selisih berat",
    bookingStartDate: "Tanggal mulai booking",
    bookingEndDate: "Tanggal sampai booking",
    hubLocation: "Lokasi Hub",
    bookingUser: "User pembooking",
    destinationSummary: "Kota Tujuan",
    commoditySummary: "Komoditi",
    cargoChoice: "Pilihan Kargo",
    cargoRecommendation: "Rekomendasi Kargo",
    client: "Klien",
    weight: "Berat",
    totalWeight: "Total berat",
    totalVolume: "Total berat volume",
    direct: "Langsung",
    totalTransit: "Jumlah transit",
    transitAirport: "Bandara transit {index}",
    pieceDimension: "Dimensi Koli",
    estimatedDeparture: "Estimasi keberangkatan",
    flyIn: "Terbang Dalam",
    routeFlight: "Rute penerbangan",
    planeScheduleNumber: "Jadwal Pesawat {index}",
    duration: "Durasi Penerbangan",
    allFlights: "Semua penerbangan",
    minimumWeightPerPieceSmu: "SMU dengan minimum berat per koli",
    action: "Aksi",
    transitCountBadge: "{count}x transit",
    totalBagWeightDifference: "Total Bag dengan selisih berat",
    weightBagDifference: "Bag selisih berat",
    bagWithWeightDifference: "Bag dengan selisih berat",
    listSttBag: "Daftar STT/bag"
  },
  placeholders: {
    selectCargoType: "Pilih Tipe Kargo",
    selectClient: "Pilih klien",
    allClients: "Semua klien",
    selectDestinationCity: "Pilih kota tujuan",
    selectCommodity: "Pilih komoditas",
    selectProduct: "Pilih Produk",
    selectTime: "Pilih waktu",
    selectHubLocation: "Pilih lokasi hub",
    selectBookingUser: "Pilih user pembooking",
    selectStartDate: "Masukan tanggal mulai",
    selectEndDate: "Masukan tanggal selesai",
    selectOriginAirport: "Pilih bandara asal",
    selectDestinationAirport: "Pilih bandara tujuan",
    enterNog: "Masukan NOG",
    enterShc: "Masukan SHC",
    enterCargoNumber: "Masukan No. kargo",
    enterVehicleSerialNumber: "Masukan No. seri kendaraan",
    enterFlightNumber: "Masukan nomor penerbangan",
    enterCargo: "Masukan kargo",
    selectTransitAirport: "Pilih bandara transit {index}",
    enterSttBaggingOrScan: "Masukkan nomor STT/bagging atau scan barcode",
    scanSttBaggingExample:
      "Contoh: no. STT/bagging: 99LP1234567890123/88-22-12345678"
  },
  filters: {
    filter: "Filter",
    selectDate: "Pilih tanggal",
    createCargoList: "Buat daftar kargo",
    downloadFailedList: "Download daftar gagal",
    cargoTypes: {
      plane: "Pesawat",
      truck: "Truk",
      train: "Kereta",
      ship: "Kapal"
    }
  },
  messages: {
    noData: "Oops.. Belum ada data yang dapat ditampilkan",
    sttPaidTitle: "Pastikan Nomor STT Sudah Terbayar",
    sttPaidMessage:
      "Cek kembali nomor STT Adjusted atau yang kelebihan berat, pastikan sudah terbayar lunas",
    confirmCancelTitle: "Apakah anda yakin ingin membatalkan?",
    confirmCancelMessage:
      'Jika memilih "Ya" sistem akan membatalkan proses booking',
    confirmDeleteTitle: "Apakah anda yakin ingin menghapus?",
    confirmDeleteMessage:
      "Data yang sudah dihapus akan hilang dari daftar Dibatalkan/Gagal",
    confirmRebookTitle: "Konfirmasi Booking Ulang Kargo?",
    confirmRebookMessage: "Pastikan seluruh detail STT sudah benar dan sesuai",
    deleteBookingTitle: "Hapus nomor booking?",
    deleteBookingMessage:
      "<b>Nomor Booking “{bookingNumber}”</b> akan hilang & terhapus dari tabel cargo.",
    rebookBookingTitle: "Booking ulang?",
    rebookBookingMessage:
      "Apakah anda yakin ingin booking ulang <b>No. Booking “{bookingNumber}”</b>?",
    leavePageTitle: "Yakin ingin keluar?",
    leavePageMessage:
      "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
    flightScheduleNotFinishedLeave:
      "Daftar jadwal pesawat belum selesai dimuat jika kamu keluar sekarang.",
    maxPlanePiecesTitle: "Maksimal Koli Pesawat adalah 15 koli",
    maxPlanePiecesMessage:
      "Mohon ubah jumlah koli di dalam kargo atau pilih transportasi kargo lainnya",
    manualBookingWarning:
      "Jika memilih booking manual. Anda harus booking terlebih dulu di sistem nGen.",
    fillBookingData: "Lengkapi data booking",
    fillFormData: "Lengkapi data berikut",
    selectPlaneSchedule: "Pilih jadwal pesawat",
    destinationAirportHeading: "Bandara Tujuan",
    continueBookingCargo: "Lanjutkan Booking Cargo",
    checkAvailability: "Cek ketersediaan",
    unsupportedDg: "Maskapai ini tidak dapat kirim barang DG.",
    fastestArrivalEta: "Paling cepat sampai (ETA)",
    onTimeDeparture: "Keberangkatan on-time",
    processing: "Sedang Diproses",
    pleaseTryAgain: "Silahkan coba lagi",
    unavailable: "Tidak Tersedia",
    available: "Tersedia",
    dataNotFound: "Data tidak ditemukan",
    searchDataNotFound: "Maaf, data yang Anda cari tidak ditemukan.",
    readyToCargoClientFilterNoData:
      "Belum ada daftar siap dikargo yang sesuai filter klien ini.",
    checkOrChangeFilter: "Cek kembali atau ubah filter Anda.",
    downloadFailed: "Download Gagal !",
    cutOffSchedulePassed:
      "Cut off time kargo sudah lewat, pilih ulang jadwal keberangkatan pesawat",
    searchDeadlineExceededMax:
      "Batas waktu pencarian melebihi batas maksimum {minutes} menit.",
    dataUpdatedCheckAgain: "Ada pembaharuan data, silakan cek kembali",
    sttBagCannotUpdateTitle: "Ada STT/Bag tidak dapat update Kargo.",
    sttBagCannotUpdateMessage:
      "Ada STT/bag yang tidak bisa diproses sebagai kargo, silahkan cek kembali.",
    serverConnectionFailed: "Gagal terhubung ke server",
    cutOffCyclePassed: "Cut off time cycle sudah lewat.",
    cutOffNear: "Cycle mendekati cut off time, segera booking sekarang!",
    weightExceededLimit: "Berat melebihi batas",
    piecesExceededLimit: "Koli melebihi batas",
    volumeExceededLimit: "Berat volume melebihi batas",
    totalPiecesMaxLimit: "Total koli melebihi batas maksimum {max} koli.",
    totalGrossWeightMaxLimit: "Total berat melebihi batas maksimum {max} kg.",
    totalVolumeWeightMaxLimit:
      "Total berat volume melebihi batas maksimum {max} kg.",
    cargoWeightExceedsReweigh: "Berat kargo melebihi berat timbang ulang",
    dataChanged: "Terjadi perubahan data",
    planeVolumeDividerInfo:
      "Total berat volume kargo pesawat akan dibagi {divider} dari dimensi.",
    editDimensionIfChanged: "Edit jika dimensi berubah",
    calculating: "Sedang dihitung",
    totalActualGrossWeightRequired:
      "Total berat kotor kargo aktual wajib diiisi",
    totalActualVolumeWeightRequired:
      "Total berat volume kargo aktual wajib diisi",
    totalActualPiecesRequired: "Total koli aktual wajib diisi",
    actualDimensionRequired: "Dimensi wajib diisi",
    totalSttChangedAdjustDimension: "Total STT Berubah, sesuaikan dimensi koli",
    pieceValueGreaterThanTotal:
      "Nilai koli lebih besar dari total koli, ubah dan simpan dengan nilai yang sama",
    pieceValueLessThanTotal:
      "Nilai koli lebih kecil dari total koli, ubah dan simpan dengan nilai yang sama",
    pieceDetailRequired:
      "Total Koli, Nilai Koli, Dimensi, dan Berat Volume harus diiisi",
    pieceDimensionSavedTitle: "Dimensi Koli Berhasil Disimpan",
    pieceDimensionSavedMessage: "Detail dimensi koli telah berhasil disimpan",
    confirmProcessPlaneCargoTitle: "Proses kargo pesawat ini?",
    confirmFlightDetailMessage:
      "Pastikan kembali seluruh detail penerbangan sudah benar dan sesuai.",
    bookingInProcess: "Booking Kargo Sedang Diproses",
    bookingRequestInProcess:
      "Booking Kargo {bookingRequestId} <br/> Sedang Diproses",
    bookingSuccessNotification:
      "Anda akan mendapat notifikasi jika booking kargo berhasil",
    ngenProcessFailedTitle: "Booking Kargo Gagal Diproses nGen",
    ngenProcessFailedMessage:
      "Lihat alasannya di halaman gagal booking. Cek & booking ulang",
    reschedulePlaneCargo: "Anda masih dapat menjadwalkan ulang kargo pesawat.",
    cargoNotFoundTitle: "Nomor Kargo Tidak Ditemukan",
    cargoNotFoundMessage:
      "Cek kembali nomor kargo Anda atau lakukan Booking Kargo secara manual",
    airportMismatchTitle: "Bandara asal dan tujuan tidak sesuai",
    airportMismatchMessage:
      "Pastikan nomor cargo telah sesuai, kesalahan pada nomor cargo akan menjadi tanggung jawab konsolidator terkait",
    proofPhotoChangeWeight: "Bukti Foto perubahan berat",
    uploadProofPhotoChangeWeight: "Upload bukti foto untuk ubah berat",
    volumeDividerInfo:
      "Total berat volume dibagi 6.000 dari dimensi, tapi jika pilih kargo pesawat akan dibagi 5.000 dari dimensi.",
    minimumWeightRecommendation:
      "Berat paket masih dibawah 10kg. Disarankan untuk menambahkan STT yang akan di kargo",
    labelFooterSupport:
      "Terjadi kendala pada proses pengiriman? Hubungi Customer Service 021-80820072 atau hubungi Kota Asal yang bersangkutan.",
    noCargoItems: "Tidak ada STT atau bagging di dalam kargo ini",
    totalDisputeBagging: "Total Bag dengan selisih berat",
    invalidSttBaggingCargo: "No. STT/bagging tidak bisa di booking cargo",
    cargoCommodityMismatch: "Komoditas kargo tidak sama",
    noSttBaggingFoundOrDeleted:
      "No. STT/No. Bag tidak ditemukan atau sudah terhapus",
    sttAlreadyInput: "No. STT sudah di input",
    waitCustomerPay:
      "Tunggu sampai customers selesai melunasi tagihan kurang bayar",
    cannotUpdateToCargo:
      "Terjadi kelebihan berat sehingga status tidak dapat diupdate ke Cargo.",
    createSuccessTitle: "Pembuatan Berhasil !",
    createFailedTitle: "Pembuatan Gagal!",
    createFailedMessage: "Pengiriman kargo gagal dibuat.",
    editFailedTitle: "Perubahan Gagal !",
    editFailedMessage: "Pengiriman kargo gagal diubah.",
    canceledFailedStatus: "Dibatalkan / Gagal Booking",
    bookingManual: "Booking manual",
    bookingAuto: "Booking auto",
    recommended: "Direkomendasikan",
    failedStatus: "Gagal",
    canceledStatus: "Dibatalkan",
    inProgressStatus: "Dalam Proses Booking",
    scheduleUnavailable:
      "Maaf, jadwal keberangkatan kargo pesawat sudah penuh atau tidak tersedia.",
    cargoDisputeTooltip: "Kargo dengan selisih berat",
    getDisputeSummaryFailed: "Gagal mendapatkan cargo dispute summary!",
    downloadDisputeSummaryFailed: "Gagal mendownload data dispute summary!",
    downloadMinimumWeightFailed: "Gagal mendownload data minimum weight!",
    deleteStoragePhotoFailed: "Gagal menghapus Foto ke storage!",
    confirmCreateMessage:
      "Pastikan kembali seluruh detail STT sudah benar dan sesuai.",
    proofPhotoChangeWeightAlt: "Bukti foto perubahan berat koli {index}"
  },
  analytics: {
    inputSttSuccess: "STT berhasil diinput",
    inputSttFailed: "STT gagal diinput",
    deleteSttSuccess: "STT berhasil dihapus",
    bookingCargoSuccess: "Kargo berhasil dibuat",
    bookingCargoFailed: "Kargo gagal dibuat"
  },
  widget: {
    title: "Daftar download kargo",
    reportTitlePrefix: "Daftar Kargo",
    generating: "Generate.xlsx",
    noDataFound: "Data tidak ditemukan",
    failed: "Gagal",
    download: "Download",
    printPdf: "Print PDF",
    outgoingCargoList: "Daftar Kargo Outgoing"
  },
  units: {
    minute: "Menit",
    hour: "Jam",
    kg: "Kg",
    cm: "cm"
  },
  summary: {
    show: "Lihat",
    hide: "Tutup",
    sttWeightTitle: "Ringkasan berat (STT)",
    reweighWeightTitle: "Ringkasan berat (Timbang ulang)"
  },
  uploadPhoto: {
    requiredRule:
      "Wajib upload bukti foto jika perbedaan antara berat kargo dan berat timbang ulang mencapai 1 kg atau lebih",
    guideTitle: "Panduan foto :",
    goodResolution: "Foto memiliki resolusi bagus.",
    readableScale: "Berat aktual pada timbangan harus terbaca jelas.",
    visiblePackages: "Semua paket yang ditimbang harus terlihat jelas.",
    minimumOnePhoto: "Minimal 1 foto",
    scaleWithItem: "Foto timbangan <br /> dengan barang",
    measurementWithItem: "Foto ukuran <br /> dengan barang",
    additionalPhoto: "Foto tambahan"
  },
  dispute: {
    withWeightDifference: "dengan selisih berat",
    dataRange: "Data {dateRange}",
    other: "Lainnya",
    processedInBagging: "Diproses bagging",
    processedInCargo: "Diproses kargo"
  },
  pdf: {
    manifest: {
      title: "Cargo Manifest",
      operationsSupervisor: "Supervisor Operasional",
      headers: {
        no: "No.",
        noBag: "No. Bag",
        noStt: "No. STT",
        totalPieces: "Total\nKoli",
        grossWeight: "Berat\nKotor",
        volumeWeight: "Berat\nDimensi",
        product: "Produk",
        commodity: "Komoditas",
        originShort: "Origin",
        destinationShort: "Dest.",
        bagNo: "No. Bag",
        bagDestination: "Kota tujuan bag",
        totalStt: "Total STT",
        totalPiecesCargo: "Total Koli",
        grossWeightCargo: "Berat kotor kargo",
        volumeWeightCargo: "Berat volume kargo",
        chargeableWeight: "Chargeable weight kargo",
        originConsoleCity: "Kota asal konsol",
        createdBy: "Dibuat oleh",
        createdAt: "Tanggal dibuat",
        updatedBy: "Diubah oleh",
        updatedAt: "Tanggal diubah"
      },
      table: {
        bagNo: "No. Bag",
        sttNo: "No. STT",
        grossWeight: "Berat Kotor",
        totalPieces: "Total Koli",
        volumeWeight: "Berat Volume",
        productType: "Jenis pengiriman",
        commodityName: "Komoditas",
        originCityId: "Kota asal",
        destinationCityId: "Kota tujuan"
      },
      signature: {
        courier: "Kurir"
      }
    },
    sptjElectronic: {
      title: "SURAT PERNYATAAN PENGANGKUTAN LITHIUM ION BATTERY",
      intro:
        "Sehubungan dengan adanya kerjasama keagenan kargo PT. Lion Mentari, bersama ini saya bertindak dan atas nama perusahaan kami:",
      name: "Nama",
      position: "Jabatan",
      companyName: "Nama Perusahaan",
      defaultPosition: "Operasional",
      defaultCompanyName: "Lion Parcel",
      shipmentHeader:
        "Akan melakukan pengiriman Electronic Goods menggunakan penerbangan Lion Air, dengan details sebagai berikut:",
      smuAwbNo: "SMU/AWB No",
      flightNo: "Flight No",
      flightRoute: "Rute Penerbangan",
      electronicGoodsType: "Jenis Electronic Goods",
      statementsTitle: "Bahwa dengan ini kami menyatakan:",
      point1:
        "Bahwa kami tunduk sepenuhnya kepada aturan dan ketentuan yang berlaku terkait pengiriman barang/kargo (Electronic Goods) yang telah ditetapkan PT. Lion Mentari.",
      point2:
        "Kelengkapan Dokumen Pengangkutan Lithium Ion Battery, serta Standar kemasan sudah sesuai dengan Aturan dan Ketentuan yang berlaku",
      point3: "Batasan kapasitas:",
      point3Sub1:
        "Lithium ION Cell <= 20 Wh setara dengan Kapasitas Battery Max 5.000 mAh",
      point3Sub2:
        "Lithium Battery <= 100 Wh setara dengan Kapasitas Battery Max 9.000 mAh",
      point4:
        "Bilamana terjadi kehilangan, kerusakan, incident serta accident yang timbul baik isi,/maupun kemasan atas kiriman kargo tersebut merupakan tanggung jawab kami sepenuhnya.",
      point5:
        "Bahwa semua ganti rugi atas kehilangan, kerusakan maupun keterlambatan semua pengiriman baik kiriman milik sendiri ataupun kiriman milik sub-agent kami serta pihak lainnya yang mempergunakan Surat Muatan Udara/Airwaybil (SMU/AWB) yang kami miliki merupakan tanggung jawab kami sepenuhnya.",
      point6:
        "Bahwa Surat ini dibuat dengan sebenar - benarnya, serta Salinan surat ini berlaku untuk dipergunakan sebagaimana mestinya.",
      closing:
        "Demikian surat pernyataan ini kami buat dengan sebenar-benar nya.",
      acknowledgedBy: "Diketahui oleh:",
      createdBy: "Dibuat oleh:",
      airlinesOfficer: "Petugas Airlines",
      sender: "Pengirim",
      nameAndId: "Nama & No ID",
      clearName: "Nama jelas",
      noteFile: "Nb: File surat ini disimpan di Station Origin",
      noteStrike: "(*)Dicoret salah satu saja",
      documentTitle: "SPTJ_Elektronik_{smuNo}.pdf"
    },
    sptjNonElectronic: {
      title: "SURAT PERNYATAAN",
      subtitle: "PEMBEBASAN TANGGUNG JAWAB PENGANGKUTAN CARGO",
      intro: "Saya yang bertanda tangan dibawah ini:",
      name: "Nama",
      age: "Umur",
      address: "Alamat",
      phone: "No Telepon/Hp",
      shipmentDescription:
        "Akan melaksanakan pengiriman barang kargo dengan penerbangan Lion Air/ Batik Air/ Wings Air/ Super Air Jet.",
      receiverName: "Nama Penerima",
      cargoContents: "Isi Barang/kargo",
      totalPiecesWeight: "Jumlah Koli/kg",
      shipmentOrigin: "Asal Pengiriman",
      goodsCondition: "Kondisi Barang",
      goodsConditionDefault: "BAIK & KARDUS",
      awbNo: "No. AWB/SMU",
      statementTitle: "MENYATAKAN BAHWA",
      statement1:
        "Dengan ini saya menyatakan membebaskan PT. Lion Express dari segala bentuk tanggung jawab atas segala akibat buruk pengangkutan barang / kargo milik kami tersebut diatas.",
      statement2:
        "Dalam hubungan dengan pengangkutan ini, kami telah menyetujui :",
      statement21:
        "Membebaskan pengangkut dari tanggung jawab atas kerugian-kerugian yang bagaimanapun juga yang ditimbulkan oleh kelambatan dalam pengangkutan, termasuk juga kelambatan datang serta kelambatan dalam penyerahan barang - barang.",
      statement22:
        "Membebaskan pengangkut dari tanggung jawab atas hilang sebagian atau seluruh dan atau sampai tujuan barang mudah pecah/atau rusak yang tersebut diatas.",
      statement3:
        "Segala biaya yang timbul, baik langsung maupun tidak langsung selama hubungan pengangkutan berlangsung dari tempat asal sampai tempat tujuan, menjadi tanggung jawab kami.",
      statement4:
        "Lion Air/wings Air, termasuk agen-agen kargo serta karyawannya dibebaskan dari segala tuntutan kerugian, atau biaya yang timbul atas kerusakan barang/kargo milik kami.",
      closing:
        "Demikian surat pernyataan ini kami buat dengan sebenar-benar nya.",
      airlinesOfficer: "Petugas Airlines",
      relatedParty: "Yang Bersangkutan",
      relatedPartyName: "Nama yang bersangkutan",
      note: "NB: 1 lembar untuk file STO asal & 1 lembar untuk STO tujuan",
      noteCheckPhysical: "-CHECK FISIK DAN PACKING",
      documentTitle:
        "SURAT PEMBEBASAN TANGGUNG JAWAB PENGANGKUTAN CARGO LION PARCEL {originCityCode} - {cargoNumber}"
    },
    pti: {
      title: "PEMBERITAHUAN TENTANG ISI (PTI) LION PARCEL {originCityCode}",
      signerIntro: "Yang bertanda tangan di bawah ini :",
      senderName: "Nama pengirim",
      address: "Alamat",
      phoneNumber: "Nomor Telepon",
      identity: "KTP / Identitas lainya",
      identityDefault: "LION GROUP",
      description:
        "Menerangkan bahwa kiriman yang diserahkan untuk di angkut oleh {airline} yang di alamat kan kepada :",
      receiverName: "Nama penerima",
      airwayBillNo: "Dengan SURAT MUATAN UDARA No.",
      goodsListTitle: "Berisi barang - barang sebagai berikut:",
      totalPiecesHeader: "JUMLAH KOLI",
      unitHeader: "SATUAN",
      goodsContentHeader: "ISI BARANG",
      weightKgHeader: "BERAT KG.",
      pieceUnit: "KOLI",
      totalWeight: "JUMLAH BERAT :",
      declaration:
        "Setelah dari itu pengirim menerangkan dan mengetahui bahwa pengisian pemberitahuan tentang isi. Dengan tidak benar dapat di hukum dengan denda dan / atau pensitaan atas kiriman itu. Pengirim menerangkan pula bahwa ia bersedia sewaktu-waktu membayar ganti rugi yang di sebabkan karena pemberitahuan tentang isi telah di isi tidak dengan sebenarnya.",
      signAndName: "(Tanda Tangan & Nama Jelas Pengirim)",
      documentTitle:
        "PEMBERITAHUAN TENTANG ISI (PTI) LION PARCEL {originCityCode} - {cargoNumber}"
    }
  },
  stepper: {
    addStt: "Tambah STT",
    findCargo: "Cari Kargo",
    processCargo: "Proses Kargo",
    backToPreviousStepTitle: "Yakin Kembali ke Halaman Sebelumnya ?",
    backToPreviousStepMessage:
      "Anda akan mengulang proses yang sebelumnya apabila anda kembali"
  },
  gamification: {
    warning:
      "Sebelum melanjutkan Booking, Anda harus masukkan persetujuan terlebih dahulu. Anda cukup mengikuti teks yang sudah tersedia",
    instruction: "Ketik Kalimat Sesuai Petunjuk",
    errorMessage:
      "Ketik kalimat sesuai kata, spasi, tanda baca, huruf besar & kecil yang ada di kotak"
  },
  planeSchedule: {
    airportFilter: "Bandara {count}",
    transitFilter: "Transit {count}",
    transitCount: "{count} Transit",
    transitTwoOrMore: ">= 2 transit",
    sort: "Urutkan",
    searchDeadline: "Batas waktu pencarian",
    direct: "Langsung",
    earliestArrival: "Kedatangan tercepat",
    earliestDeparture: "Keberangkatan tercepat",
    shortestLeg: "Leg terpendek",
    loadingTitle: "Daftar jadwal pesawat sedang dimuat",
    internetTitle: "Jaringan internet terputus",
    serverTitle: "Terjadi gangguan sistem",
    emptyTitle: "Jadwal keberangkatan kargo pesawat tidak tersedia",
    loadingMessage: "Kami sedang mencari jadwal yang sesuai untuk Anda.",
    internetMessage: 'Periksa jaringan internal Anda lalu klik "Muat ulang".',
    serverMessage: 'Klik "Muat ulang" atau coba beberapa saat lagi.',
    emptyMessage: "Ubah & cek kembali pencarian jadwal pesawat Anda.",
    showingAllToDestinationCity:
      "Menampilkan semua kargo pesawat ke kota tujuan Anda.",
    showingAllToDestinationAirport:
      "Menampilkan semua kargo pesawat ke bandara tujuan Anda.",
    showingAllToTransitAirport:
      "Menampilkan semua kargo pesawat ke bandara transit {index}"
  },
  readyToCargo: {
    tabProcessTitle: "Dalam Proses Siap Dikargo",
    tabReadyListTitle: "Daftar Siap Dikargo",
    searchPlaceholderProcess: "Cari No. Bagging / STT",
    filter: "Filter",
    tambah: "Tambah",
    statusDalamProses: "Dalam Proses",
    statusGagalDiproses: "Gagal Diproses",
    statusBerhasilDiproses: "Berhasil Diproses",
    colNoBaggingStt: "No. Bagging/STT",
    colDiperbaruiOleh: "Diperbarui Oleh",
    colKotaAsal: "Kota Asal",
    colKotaTujuan: "Kota Tujuan",
    status: "Status",
    deskripsi: "Deskripsi",
    searchPlaceholderReady: "Cari No. Siap di Kargo",
    pilihStatus: "Pilih Status",
    harusDikargo: "Harus Dikargo",
    bisaDikargo: "Bisa Dikargo",
    no: "No.",
    noSiapKargo: "No. Siap Kargo",
    totalKoli: "Total Koli",
    totalBagging: "Jumlah Bagging",
    tipeKargo: "Tipe Kargo",
    proses: "Proses",
    modalProcessTitle: "Apakah anda ingin Memproses {no}?",
    modalProcessMessage:
      "Pastikan anda sudah mengumpulkan semua bagging di 1 tempat yang sama",
    kembali: "Kembali",
    tooltipStatusMin:
      "Nilai minimal berat bagging belum tercapai dan bisa diproses kargo",
    tooltipStatusMax:
      "Nilai maksimal berat bagging telah tercapai dan harus diproses kargo",
    tambahData: "Tambah Data",
    noSttNoBagging: "No. STT/No. Bagging",
    labelStackedExample:
      "Contoh : No. STT/No. Bagging : 99LP1234567890123/88-22-12345678",
    placeholderInput: "Masukan No. STT/No. Bagging atau Scan Barcode",
    hapus: "Hapus",
    modalSuccessTitle: "Bagging dan STT Akan Diproses RTC",
    modalSuccessMessage:
      "Silahkan lihat bagging dan STT Anda saat proses booking kargo",
    modalPartialTitle: "Sebagian Data Gagal ditambahkan.",
    modalPartialMessage:
      "Beberapa STT/Bagging gagal ditambahkan ke Siap di Kargo. Silahkan download untuk cek detail.",
    modalFailedTitle: "Tambah Data Gagal",
    modalFailedMessage:
      "Tambah data Bagging dan STT gagal dilakukan. Silahkan download untuk cek detail.",
    download: "Download",
    sttBerhasilDihapus: "STT Berhasil Dihapus",
    modalDeleteMessage: "Anda dapat menambahkan STT baru ke daftar pengiriman",
    hapusStt: "Hapus STT",
    batalkan: "Batalkan",
    wordingDeleteStt: "STT yang Anda hapus akan hilang dari daftar pengiriman",
    wordingDeleteBag:
      "Semua STT dari No. Bag yang sama akan terhapus dari daftar pengiriman",
    noBag: "No. Bag",
    noStt: "No. STT",
    noReferensi: "No. Referensi",
    beratKotor: "Berat Kotor",
    beratDimensi: "Berat Dimensi",
    produk: "Produk",
    komoditas: "Komoditas",
    action: "Action",
    ok: "OK",
    errorAdjustmentNotApproved:
      "Adjustment STT belum disetujui tim Lion Parcel, tunggu follow up dari CS.",
    errorScanAdjustmentNotApproved:
      "Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS.",
    titleSttNotRtc: "No. STT tidak bisa di RTC",
    titleBaggingNotRtc: "No. Bagging tidak bisa di RTC",
    waitCustomerPay:
      "Tunggu sampai customers selesai melunasi tagihan kurang bayar",
    sttUnderpaidInBag: "Terdapat STT Kurang Bayar",
    statusSttHasBeen: "Status STT ini telah {status}",
    statusBaggingNotMatch: "Status STT pada Bagging tidak sesuai",
    errorSttAlreadyInput: "No. STT sudah di input",
    scanFailedListTitle: "Daftar STT/Bag gagal scan",
    excelHeaderSttBag: "Nomor STT/Bag",
    excelHeaderLastStatus: "Status Terakhir STT/Bag",
    excelHeaderFailureReason: "Alasan Gagal",
    excelHeaderDemNo: "Nomor DEM",
    excelHeaderSttNo: "Nomor STT",
    excelHeaderLastStatusDispatch: "Status Terakhir STT",
    sheetNameScanFailed: "STT gagal scan",
    fileNameScanFailed: "STT gagal scan.xlsx"
  },
  v2: {
    daftar: {
      pageTitle: "Daftar CARGO"
    },
    badge: {
      dangerousGoods: "Dangerous Goods",
      quarantine: "Karantina",
      new: "Baru"
    },
    column: {
      transitCount: "{count} transit",
      viewMorePrintStatus: "Lihat lainnya",
      printStatus: "Status print",
      etd: "ETD",
      totalPiecesGrossWeightShort: "Total koli/Gross w.",
      piecesGrossWeightValue: "{pieces} koli / {weight} kg",
      reason: "Alasan"
    },
    datetime: {
      timezoneSuffix: "{date} WIB"
    },
    print: {
      labelCargo: "Label kargo",
      awbLionCargo: "AWB Lion Cargo",
      pti: "PTI",
      sptj: "SPTJ",
      manifestCargo: "Manifest kargo"
    },
    actions: {
      printLabel: "Print Label kargo",
      printManifest: "Print Manifest kargo",
      printAwb: "Print AWB Lion Cargo",
      printPti: "Print PTI",
      printSptj: "Print SPTJ",
      printSptjElectronic: "Print SPTJ"
    },
    etd: {
      dayOffsetSingular: "+1 hari",
      dayOffsetPlural: "+{count} hari"
    },
    filter: {
      searchPlaceholder: "No.kargo/SMU",
      selectAll: "Semua",
      moda: "Moda",
      selectModa: "Pilih moda"
    },
    empty: {
      reasonUnavailable: "Belum tersedia"
    },
    errors: {
      downloadFailedList: "Download daftar gagal!"
    },
    detail: {
      tooltip: {
        cargoWeightDispute: "Kargo dengan selisih berat",
        cargoNog: "Isi NOG sesuai komoditas barang dalam kargo.",
        shcCode:
          "SHC akan terisi otomatis berdasarkan komoditas kargo yang dipilih."
      },
      badge: {
        quarantine: "Karantina",
        inProgress: "Dalam proses booking",
        cancelledFailed: "Dibatalkan/Gagal booking"
      },
      action: {
        delete: "Hapus",
        rebook: "Booking ulang",
        editBooking: "Ubah booking",
        viewPhotoProof: "Lihat {count} bukti foto lainnya"
      },
      modal: {
        delete: {
          title: "Hapus nomor booking?"
        },
        rebook: {
          title: "Booking ulang?"
        }
      },
      tab: {
        info: "Detail Informasi",
        history: "Riwayat status kargo"
      },
      error: {
        fetchDetail: "Gagal Mengambil Detail Kargo"
      },
      print: {
        label: "Label kargo",
        manifest: "Manifest kargo"
      },
      field: {
        bookingDate: "Tanggal booking",
        lastUpdated: "Terakhir diupdate",
        commodity: "Komoditas",
        product: "Produk",
        sttWeight: "Berat STT",
        cargoWeight: "Berat kargo"
      },
      section: {
        printLabel: "Label kargo",
        printManifest: "Manifest kargo",
        weightDispute: "Selisih berat",
        sttList: "Daftar STT",
        bagList: "Daftar bag"
      },
      disputeStatus: {
        bagging: "Diproses bagging",
        cargo: "Diproses kargo"
      }
    },
    dispute: {
      photo: {
        viewProof: "Lihat foto bukti"
      }
    },
    history: {
      empty: {
        noData: "Oops.. Belum ada data yang dapat ditampilkan"
      },
      link: {
        deliveryProof: "Lihat bukti pengiriman",
        weightChangePhoto: "Lihat foto perubahan berat"
      },
      field: {
        coliCount: "Jumlah koli"
      },
      direct: "Langsung",
      close: "Tutup",
      flightDetails: "Detail penerbangan"
    },
    flight: {
      search: {
        title: {
          selectSchedule: "Pilih jadwal"
        },
        action: {
          reload: "Muat ulang",
          apply: "Terapkan"
        },
        empty: {
          loadingTitle: "Daftar jadwal pesawat sedang dimuat",
          serverErrorTitle: "Terjadi gangguan sistem",
          networkErrorTitle: "Jaringan internet terputus",
          filterNotFoundTitle: "Hasil tidak ditemukan",
          noScheduleTitle: "Tidak ada jadwal penerbangan yang tersedia",
          loadingMessage: "Kami sedang mencari jadwal yang sesuai untuk Anda.",
          serverErrorMessage: "Silahkan coba beberapa saat lagi",
          networkErrorMessage: "Silahkan periksa jaringan internet Anda",
          filterNotFoundMessage: "Cek dan atur ulang filter yang Anda cari.",
          noScheduleMessage: "Ubah tanggal atau filter untuk menemukan jadwal…"
        },
        header: {
          totalPieces: "Total Koli",
          grossVolumeWeight: "Gross w./ Volume w."
        },
        date: {
          selectOther: "Pilih tanggal lain"
        },
        filter: {
          selectAirport: "Pilih bandara",
          originAirport: "Bandara asal",
          destinationAirport: "Bandara tujuan",
          transitCount: "Jumlah transit",
          selectTransitCount: "Pilih jumlah transit",
          sort: "Urutkan",
          selectSort: "Pilih urutan",
          thresholdTime: "Batas waktu",
          selectThreshold: "Pilih batas waktu",
          hours12: "12 jam dari sekarang",
          hours24: "24 jam dari sekarang",
          airportRoute: "Bandara {origin} - {destination}",
          airportOriginOnly: "Bandara {origin}",
          airportDestinationOnly: "Bandara {destination}",
          originLabel: "asal {list}",
          destinationLabel: "tujuan {list}",
          direct: "Langsung",
          transit1: "1 transit",
          transit2: "2 transit",
          transit3: ">3 transit",
          fastestEta: "ETA tercepat",
          fastestEtd: "ETD tercepat"
        },
        card: {
          arrivalDayOffset: "+{count} hari",
          volumeUnavailable: "Volume pesawat tidak mencukupi",
          dimensionUnavailable: "Dimensi pesawat tidak mencukupi",
          capacityUnavailable: "Kapasitas pesawat tidak mencukupi",
          embargo: "Rute Embargo",
          capacityAvailable: "Kapasitas tersedia",
          dgNotAllowed: "Tidak bisa kirim barang DG",
          potentialDelay: "Potensi delay",
          onTime: "On-time",
          departsIn: "Terbang dalam",
          duration: "{hours} jam {mins} menit",
          viewTransitDetail: "Lihat detail transit",
          closeTransit: "Tutup",
          booking: "Booking",
          transitCapacity: "Kapasitas • {kg} kg",
          direct: "Langsung",
          transitLabel: "{count} transit",
          durationZero: "0 menit",
          durationMinutes: "{mins} menit",
          durationHours: "{hours} jam",
          durationHoursMinutes: "{hours} jam {mins} menit"
        },
        modal: {
          delay: {
            title: "Konfirmasi jadwal delay",
            route: "Rute",
            departure: "Keberangkatan",
            arrival: "Kedatangan",
            changeSchedule: "Ganti jadwal",
            confirmBooking: "Ya, Booking"
          }
        }
      }
    },
    nog: {
      error: {
        required: "NOG wajib diisi"
      }
    }
  }
};
